const tableData = {
  columns: [
    { name: "first_name", align: "center" },
    { name: "last_name", align: "center" },
    { name: "role", align: "center" },
    { name: "facility", align: "center" },
    { name: "email", align: "center" },
    { name: "Census_access", align: "center" },
    { name: "Dashboards_access", align: "center" },
    { name: "Biller", align: "center" },
    { name: "census_edit_permission", align: "center" },
    { name: "actions", align: "center" },
  ]
};

export default tableData;